import axiosClient from '../../common/axiosInstance';
import { getDeviceLogs } from '../../utils/deviceInfo';

export const ExpertiseService = {
  getInfoCar: (company, codeSnippet) => {
    return axiosClient.get(`/partner/get-info-car-autocare-${company}/${codeSnippet}`, {
      params: { divide_logs: getDeviceLogs() },
    });
  },

  getDoctype: (company, id, insurerBranchId) => {
    let params = {
      InsurerBranchId: insurerBranchId,
      policyNumber: id,
    };
    let subUrl = '-partner';

    if (company === 'liberty') {
      subUrl = '-liberty/' + id;
      params = {};
    }

    return axiosClient.get(`/partner/get-doctype-autocare${subUrl}`, { params });
  },

  validatePreinspection: (url, params) => {
    return axiosClient.get(url, { params });
  },

  confirmInfo: (body) => {
    return axiosClient.post('/partner/confirm-info', body);
  },

  deleteImages: (pidPpiSysId, data) => {
    return axiosClient.post(`/partner/delete-images-pi/${pidPpiSysId}`, { data });
  },

  createDoctype: (orderId, doctype) => {
    return axiosClient.post(`/partner/create-doctype-pi/${orderId}`, { doctype });
  },

  aiCheck: (params, url = '/partner/ai-check') => {
    // Same as the upload call: a stale portal token must not turn the cancel into a 401/403
    // (the interceptor would redirect to /login and the cancel would be lost).
    return axiosClient.put(url, null, { params, 'unuse-authorization': true });
  },

  verifyPolicyImage: (urlAppend, formData, config) => {
    return axiosClient.post('/partner/verify-policy-image-autocare-' + urlAppend, formData, config);
  },
};
